import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import { auth } from '../services/firebase';
import { FileText, FolderOpen, LogOut } from 'lucide-react';

const AdminDashboard: React.FC = () => {
    const { user } = useContext(AuthContext);

    const handleSignOut = async () => {
        await auth.signOut();
    };

    return (
        <div className="mx-auto max-w-3xl md:border-x">
            <div className="px-4 py-12">
                <div className="flex items-center justify-between mb-12">
                    <div>
                        <h1 className="text-2xl font-bold text-foreground">Admin Dashboard</h1>
                        <p className="text-sm text-muted-foreground mt-1">
                            Signed in as {user?.email}
                        </p>
                    </div>
                    <button
                        onClick={handleSignOut}
                        className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground hover:text-foreground border border-border rounded-md transition-colors"
                    >
                        <LogOut size={14} />
                        Sign Out
                    </button>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                    <Link
                        to="/admin/articles"
                        className="group p-8 border border-border rounded-lg hover:bg-accent transition-colors"
                    >
                        <FileText size={24} className="text-muted-foreground group-hover:text-foreground mb-4" />
                        <h2 className="text-lg font-semibold text-foreground mb-1">Articles</h2>
                        <p className="text-sm text-muted-foreground">
                            Create, edit, and manage blog posts.
                        </p>
                    </Link>

                    <Link
                        to="/admin/projects"
                        className="group p-8 border border-border rounded-lg hover:bg-accent transition-colors"
                    >
                        <FolderOpen size={24} className="text-muted-foreground group-hover:text-foreground mb-4" />
                        <h2 className="text-lg font-semibold text-foreground mb-1">Projects</h2>
                        <p className="text-sm text-muted-foreground">
                            Create, edit, and manage projects.
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
